import { Component, Input, forwardRef } from '@angular/core';
import { UserPresetsInterface } from '../../interfaces';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import {NgForOf, NgIf} from '@angular/common';

@Component({
  selector: 'app-user-presets',
  templateUrl: './user-presets.component.html',
  styleUrls: ['./user-presets.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserPresetsComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [FormsModule, IonicModule, NgIf, NgForOf],
})
export class UserPresetsComponent implements ControlValueAccessor {
  @Input() userPresets: UserPresetsInterface;
  @Input() label: string;
  @Input() disabled = false;
  @Input() color: string;

  private _onChange = (_) => {};

  constructor() {}

  writeValue(obj: UserPresetsInterface): void {
    this.userPresets = obj;
  }
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(): void {
    //    console.log('HI i\'m here.',this.punchPresets);
    this._onChange(this.userPresets);
  }
}
